import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { VisitorregService } from '../../../../_services/visitorreg/visitorreg.service';
@Component({
  selector: 'app-visitor-register',
  templateUrl: './visitor-register.component.html',
  styleUrls: ['./visitor-register.component.scss']
})
export class VisitorRegisterComponent implements OnInit {
  visitorForm
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  currentUser: any;
  selectedFile: File;
  form: FormGroup;
  sampleGridFrameworkComponents: any;
  gridLength = 0;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  userDropdownList = [];

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private visitorregService: VisitorregService,
    private allocationService: AllocationService,
  ) { 
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
      this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();  

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.visitorForm = new FormGroup({
      id: new FormControl(''), 
      name: new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z ]*$') ]),
      location: new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z ]*$') ]),
      company: new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z ]*$') ]),
      mobileNo: new FormControl('', [Validators.pattern('^[0-9]*$'), Validators.minLength(10), Validators.maxLength(10)] ),
      personToMeet: new FormControl('', Validators.required),
      reasonToMeet: new FormControl('', Validators.required),
      laptopSerialNo: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      pendriveDetails: new FormControl(''),
      visitorCardNo: new FormControl('', [ Validators.required, Validators.pattern('^[0-9]*$') ]),
      signature: new FormControl(''),
      inTime: new FormControl('', Validators.required),
      outTime:new FormControl('', Validators.required),
    })
  }

    // getter for easy access to form fields
    get f() {
      return this.visitorForm.controls;
    }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getVisitorData()
    this.getUserList()
  }

  getUserList() {
    this.userDropdownList = []
    this.allocationService.getUserDetails().subscribe(response => {
      for (let item of response) {
        this.userDropdownList.push(` ${item.firstName} ${item.lastName}`)
      }
    })
  }

  getVisitorData() {
    this.visitorregService.getAllvisitor().subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

   // create column definitions  
   private createColumnDefs() {
    return [
    //   {
    //   headerName: '', 
    //   width: 150,
    //   field: 'delete', 
    //   cellRenderer: "actionRowRendererComponent",
    //   cellRendererParams: {
    //     onClick: this.performGridActionItem.bind(this),
    //     deleteRequired: true,
    //   }
    // },
    {
      headerName: 'Name',
      field: 'name',
      filter: true,
      editable: false,
      sortable: true,
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
    },
    {
      headerName: 'Location',
      field: 'location',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Mobile No',
      field: 'mobileNo',
      filter: true,
      editable: false,
      sortable: true
    },
    {
      headerName: 'Company',
      field: 'company',
      filter: true,
      editable: false,
      sortable: true
    }]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }


  createvisitor() {
    let details = {
      name: this.visitorForm.get('name').value,
      location: this.visitorForm.get('location').value,
      company: this.visitorForm.get('company').value,
      mobileNo: this.visitorForm.get('mobileNo').value,
      personToMeet: this.visitorForm.get('personToMeet').value,
      reasonToMeet: this.visitorForm.get('reasonToMeet').value,
      laptopSerialNo: this.visitorForm.get('laptopSerialNo').value,
      pendriveDetails: this.visitorForm.get('pendriveDetails').value,
      visitorCardNo: this.visitorForm.get('visitorCardNo').value,
      signature: this.visitorForm.get('signature').value,     
      inTime: this.visitorForm.get('inTime').value.substring(0,10)+" "+this.visitorForm.get('inTime').value.substring(11,16)+":00",
      outTime: this.visitorForm.get('outTime').value.substring(0,10)+" "+this.visitorForm.get('outTime').value.substring(11,16)+":00",
    }
    this.visitorregService.createvisitor(details).subscribe(response => {
      console.log("response: ", response);
      
      // update grid after creating new lead & close the modal
      this.api.applyTransaction({ add: [response] });
      $('#closeCreateModal').trigger("click");
    });
  }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.visitorregService.deletevisitor(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.visitorForm.patchValue(this.selectedCheckboxData[0])
  }

  createOpenModal() {
    this.modeAction = 1;
    this.visitorForm.reset();
    this.visitorForm.patchValue({
      id:  '', 
      name:  '',
      location:  '',
      company:  '',
      mobileNo:  '',
      personToMeet:  '',
      reasonToMeet:  '',
      laptopSerialNo:  '',
      pendriveDetails:  '',
      visitorCardNo:  '',
      signature:  '',
      inTime:  '',
      outTime: '',
    });
  }

  updatevisitor() {
    let detail = {
      id: this.selectedCheckboxData[0].id, 
      name: this.visitorForm.get('name').value,
      location: this.visitorForm.get('location').value,
      company: this.visitorForm.get('company').value,
      mobileNo: this.visitorForm.get('mobileNo').value,
      personToMeet: this.visitorForm.get('personToMeet').value,
      reasonToMeet: this.visitorForm.get('reasonToMeet').value,
      laptopSerialNo: this.visitorForm.get('laptopSerialNo').value,
      pendriveDetails: this.visitorForm.get('pendriveDetails').value,
      visitorCardNo: this.visitorForm.get('visitorCardNo').value,
      signature: this.visitorForm.get('signature').value,  
      inTime: this.visitorForm.get('inTime').value.substring(0,10)+" "+this.visitorForm.get('inTime').value.substring(11,16)+":00",
      outTime: this.visitorForm.get('outTime').value.substring(0,10)+" "+this.visitorForm.get('outTime').value.substring(11,16)+":00",
    }
    this.visitorregService.updatevisitor(detail, this.selectedCheckboxData[0].id).subscribe(res => {
      this.getVisitorData();
      this.selectedCheckboxData = []
      $('#closeCreateModal').click()
    })
  }

  

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].name}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].name}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].name}`;
    }
  }

  deletevisitorList() {
    this.visitorregService.deletevisitor(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getVisitorData();
      this.selectedCheckboxData = []
      $('#closeModalDeleteVisitor').click()
    });
  }


}
